import { useContext } from "react";
import { AppContext } from "../App";

function Tags({ product }) {
	const { getTranslatedString } = useContext(AppContext);
	if (!Array.isArray(product?.tags) || product.tags.length === 0) return null;

	return (
		<div className="tags">
			{product.tags.map((tag, i) => {
				const mode = Number(tag.mode || 1);
				const showImage = (mode === 2 || mode === 3) && !!tag.img;
				const showText = mode !== 2;

				if (!showImage && !showText) return null;

				return (
					<div
						key={i}
						className={`tags-badge${showImage && !showText ? " tag-chip--image-only" : ""}`}
						style={
							tag.color
								? {
										color: tag.color,
										borderColor: tag.color,
										backgroundColor: `${tag.color}1A`,
								  }
								: undefined
						}
					>
						{showImage ? (
							<img
								className="tag-chip__img"
								src={tag.img}
								alt={showText ? getTranslatedString(tag, "name") || "tag" : ""}
							/>
						) : null}
						{showText ? <span>{getTranslatedString(tag, "name")}</span> : null}
					</div>
				);
			})}
		</div>
	);
}

export default Tags;
